import api from "../apiClient";

export const listPayments = (params = {}) => api.get("/payments/", { params });

// FieldRoutes invoices are exposed at /api/invoices/ (list view).
export const listInvoices = (params = {}) => api.get("/invoices/", { params });

// billing_app Invoice endpoints (CRM-native invoices)
export const listBillingInvoices = (params = {}) =>
  api.get("/billing/invoices/", { params });

export const listCustomerInvoices = (customerId, params = {}) =>
  api.get("/billing/invoices/", { params: { customer: customerId, ...params } });

export const getBillingInvoice = (id) =>
  api.get(`/billing/invoices/${id}/`);

export const recordManualPayment = (invoiceId, payload) =>
  api.post(`/billing/invoices/${invoiceId}/payments/manual/`, payload);

// Stripe Connect (Accounts v2, embedded onboarding).
// Returns { client_secret, publishable_key, account_id, onboarding_status }.
// Creates the connected account if none exists, so call it ONLY from an explicit
// click, with { confirm: true } (the backend refuses without it). Never on load.
export const startConnectOnboarding = (payload = {}) =>
  api.post("/billing/connect/onboard/", payload);

// Returns { connected, eligible, onboarding_status, charges_enabled, ... }.
export const getConnectStatus = (params = {}) =>
  api.get("/billing/connect/status/", { params });

